/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class MediaApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `MediaModule.forRoot()`
 */
export interface MediaApiConfigurationParams {
  rootUrl?: string;
}
